module.exports = __webpack_public_path__ + "img/img_judges1.f641f65d.png";